import {Background,Container,WrapSocialMedia} from "./styled"

const Footer = ()=>{
    return(
        <Background>
            <Container>
                <img src="https://lp-bria-assets.s3.amazonaws.com/footer/LogoFooter.png" alt=""/>
                <WrapSocialMedia>
                    <img src="https://lp-bria-assets.s3.amazonaws.com/footer/facebook.png" alt=""/>
                    <img src="https://lp-bria-assets.s3.amazonaws.com/footer/linkedin.png" alt=""/>
                    <img src="https://lp-bria-assets.s3.amazonaws.com/footer/instagram+1.png" alt=""/>
                </WrapSocialMedia>
            </Container>
        </Background>
    )
}
export default Footer